import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

// declare webkit & chrome for platform detection
declare global {
  interface Window {
    webkit?: {
      messageHandlers?: any;
    };
  }
}

const isMacOSApp = window.webkit?.messageHandlers?.callbackHandler;

const openBillingWithSafari = async () => {
  const current_url = window.location.href;
  window.webkit.messageHandlers.callbackHandler.postMessage({ 
      action: "redirectLocation", 
      url: current_url 
  });
};

const subscriptions = [
  { name: 'Starter', path: '/subscribe/starter', img: '/plan/starter.png', price: "15.00", max: "10" },
  { name: 'Essential', path: '/subscribe/essential', img: '/plan/essential.png', price: "30.00", max: "20" },
  { name: 'Plus', path: '/subscribe/plus', img: '/plan/plus.jpg', price: "45.00", max: "30" },
  { name: 'Advanced', path: '/subscribe/advanced', img: '/plan/advanced.png', price: "60.00" , max: "40"},
  { name: 'Pro', path: '/subscribe/pro', img: '/plan/pro.png', price: "75.00", max: "50" },
  { name: 'Business', path: '/subscribe/business', img: '/plan/business.jpg', price: "120.00", max: "80" },
  { name: 'Premium', path: '/subscribe/premium', img: '/plan/premium.png', price: "150.00", max: "100" },
  { name: 'Elite', path: '/subscribe/elite', img: '/plan/elite.png', price: "225.00", max: "150" },
  { name: 'Ultimate', path: '/subscribe/ultimate', img: '/plan/ultimate.jpg', price: "300.00", max: "200" },
  { name: 'Infinity', path: '/subscribe/infinity', img: '/plan/infinite.jpg', price: "450.00", max: "∞" },
];

const BillingScreen = () => {
  // I18N
  const { t } = useTranslation();
  // NAVIGATION
  const navigate = useNavigate();

  useEffect(() => {
    document.title = t('title.billing');
    if (isMacOSApp) {
      (async () => {
        await openBillingWithSafari();
        navigate(t('link.dashboard'), { state: { status: "bg-success", title: "", toastMessage: t('profile.change_plan'), toastUsername: false }});
      })();
    }
  }, []);

  return (
    <div className="container mt-5">
      <h2 className="mb-4 text-center">{t('billing.pick_subscription')}</h2>
      <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 pb-5">
        {subscriptions.map((sub, index) => (
          <div key={index} className="col">
            <Link to={sub.path} className="text-decoration-none text-dark">
              <div className="card h-100 shadow-sm border-0">
                <img src={sub.img} className="card-img-top bg-dark" alt={`${sub.name} plan`} />
                <div className="card-body text-center">
                  <h5 className="card-title">{sub.name}</h5>
                  <p className="card-text">{t('billing.subscription')}<b>{sub.max}</b>{t('billing.workers')}</p>
                  <p className="card-text">{t('billing.price')}{sub.price}{t('billing.by_mount')}</p>
                </div>
                { sub.name == "Starter" &&
                  <img src="/plan/trial.png" style={{margin: '0 auto', width: 100, height: 50, marginBottom: 10}} />
                }
              </div>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BillingScreen;